"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Grid_1 = __importDefault(require("../../Grid"));
var Title_1 = __importDefault(require("./Title"));
var CloseButton_1 = __importDefault(require("./CloseButton"));
var useStyles_1 = __importDefault(require("./useStyles"));
var Header = function () {
    var classes = (0, useStyles_1.default)();
    return (react_1.default.createElement("div", { className: classes.container },
        react_1.default.createElement(Grid_1.default, { container: true, justify: "space-between", alignItems: "center" },
            react_1.default.createElement(Grid_1.default, { item: true },
                react_1.default.createElement(Title_1.default, null)),
            react_1.default.createElement(Grid_1.default, { item: true },
                react_1.default.createElement(CloseButton_1.default, null)))));
};
exports.default = Header;
